import { Box } from '@mui/material';
import { EnrollNodeEditor } from './sidebar-views/editors/enroll-node/enroll-node-editor';
import { EditNodeFormProps } from './edit-node-form.types';
import { WaitNodeEditor } from './sidebar-views/editors/wait-node/wait-node-editor';
import { ActionNodeEditor } from './sidebar-views/editors/action-node/action-node-editor';

const editors: Partial<Record<string, React.ComponentType<EditNodeFormProps>>> = {
  enroll: EnrollNodeEditor,
  wait: WaitNodeEditor,
  action: ActionNodeEditor,
};

export const EditNodeForm = (props: EditNodeFormProps) => {
  const Editor = editors[String(props.node.type)];

  if (!Editor) {
    return (
      <Box>
        No editor registered for node type: <b>{String(props.node.type)}</b>
      </Box>
    );
  }

  return (
    <Box height="100%" display="flex" flexDirection="column" overflow="hidden">
      <Editor {...props} />
    </Box>
  );
};
